import { useNavigate } from "react-router-dom";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { hasValueObjects } from "../../utils/ManageArray";
import { addEditServiceRequest } from "../../commons/ServiceRequest";
import CreateRequisitionForm from "../../components/ReimbursementRefund/CreateRequisitionForm";
import BillOfReqHdService from "../../services/billofreqhd.service";
import BillOfReqDtService from "../../services/billofreqdt.service";

export default function CreateRequisition() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  const commonNavigate = (Bill_Of_Hd_Id) => {
    const newState = { name: "data", Bill_Of_Hd_Id };
    navigate("/reimbursement_refund/", { state: newState });
    navigate(0);
  };

  const handleSubmit = (BillOfReqHd, BillOfReqDt) => {

    console.log( BillOfReqHd, BillOfReqDt)
    let Bill_Of_Hd_Id = null;
    let newBillOfReqDt;
    let refreshAt = "";
    const commonMapping = (item) => ({ ...item, Bill_Of_Hd_Id });

    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: BillOfReqHdService?.createBillOfReqHds({
        Array: [BillOfReqHd]
      }),
      callback: (response) => {
        Bill_Of_Hd_Id = response?.generatedMaps[0]?.Id;
        newBillOfReqDt = { Array: BillOfReqDt?.map(commonMapping) };
        refreshAt = newBillOfReqDt.Array ? "ReqDt" : "ReqHd";
        if (newBillOfReqDt.Array)
          handleSubmitBillOfReqDt(newBillOfReqDt, Bill_Of_Hd_Id);
      },
      navigated: (navi) =>
        navi && refreshAt === "ReqHd" && commonNavigate(Bill_Of_Hd_Id)
    });

  };

  const handleSubmitBillOfReqDt = (data, Bill_Of_Hd_Id) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: BillOfReqDtService.createBillOfReqDts(data),
      navigated: (navi) => navi && commonNavigate(Bill_Of_Hd_Id)
    });
  };

  return <CreateRequisitionForm onSubmitCallback={handleSubmit} />;
}
